import { Component, Inject, ChangeDetectionStrategy, ChangeDetectorRef, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BusinessSignOffService } from '../business-sign-off.service';

@Component({
    selector: 'gtw-business-sign-off-edit-modal',
    templateUrl: './business-sign-off-edit-modal.component.html',
    styleUrls: ['./business-sign-off-edit-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BusinessSignOffEditModalComponent {
  private readonly destroyRef = inject(DestroyRef);


  parentMeName: string;
  desc: string;
  minimise = false;
  isSaveClicked = false;
  crudLoading = false;

  constructor(
    private dialogRef: MatDialogRef<BusinessSignOffEditModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef,
    private _snackBar: MatSnackBar,
    private businessSignOffService: BusinessSignOffService
  ) {
    this.parentMeName = data.parentMeName;
    this.desc = data.signOffDesc || '';
  }

  save(): void {
    if (this.crudLoading) {
      this._snackBar.open('Please wait while we save this request', 'Close', {
        duration: 4000,
        panelClass: ['info-snackbar']
      });
      return;
    }

    this.isSaveClicked = true;
    this.crudLoading = true;
    this.cdr.detectChanges();

    const jsonObj = {
      parent_me_code: this.data.parentMeCode,
      parent_me_name: this.data.parentMeName,
      signed_off: this.data.signedOff,
      signed_off_by: '',
      signed_off_desc: this.desc,
      sign_off_id: this.data.signOffId
    };

    const params = {
      tax_year: this.data.filterParams.tax_year,
      scenario: this.data.filterParams.scenario,
      jcd_key: this.data.filterParams.jcd_key || this.data.globalService?.globalParams?.jcd_key,
      jsonObj: JSON.stringify(jsonObj)
    };

    this.businessSignOffService.saveSignOffCmt(this.data.baseUrl, params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.isSaveClicked = false;
        this.crudLoading = false;

        if (response && (response.callSuccess == 1 || response.callSuccess === '1')) {
          this._snackBar.open('Business saved successfully...', 'Close', {
            duration: 4000,
            panelClass: ['success-snackbar']
          });
          this.dialogRef.close('saved');
        } else {
          this._snackBar.open(response.errorMessage || 'Error saving comment', 'Close', {
            duration: 4000,
            panelClass: ['error-snackbar']
          });
        }
        this.cdr.detectChanges();
      },
      (error: any) => {
        this.isSaveClicked = false;
        this.crudLoading = false;
        this._snackBar.open('Error occurred while saving. Please try again.', 'Close', {
          duration: 4000,
          panelClass: ['error-snackbar']
        });
        this.cdr.detectChanges();
      }
    );
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
